<script setup lang="ts">
const props = defineProps<{
    to?: string;
    label: string;
}>();
</script>

<template>
    <a class="inline-flex flex-row items-center justify-center gap-2 rns-big-button" :href="props.to" target="_blank">
        <i class="pi pi-print text-xl! font-bold!"></i>
        <span class="font-bold">{{ props.label }}</span>
    </a>
</template>

<style scoped>
@reference "@/styles/main.css";

.rns-big-button {
    @apply px-8 py-2 rounded-md shadow-sm hover:cursor-pointer;
    @apply text-white bg-green-600;
}
</style>
